<template>
  <div>
    <data-table ref="dataTable" :option="option"> </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";

export default {
  name: "nightCheck_nightCheckStep",
  components: { DataTable },
  props: {},
  data() {
    return {
      visible: {
        formModal: false
      }
    };
  },
  created() {
    this.option = {
      form: {
        colnum: 1,
        width: 700,
        title: "夜审步骤",
        add: {
          submitApi: "NightCheckStep_Add"
        },
        edit: {
          infoApi: "",
          submitApi: "NightCheckStep_Edit"
        },
        del: { submitApi: "NightCheckStep_Del" },
        content: [
          {
            label: "步骤序号",
            name: "StepNo",
            option: {
              rules: [{ required: true, message: "请填写步骤序号！" }]
            }
          },
          {
            label: "步骤名称",
            name: "StepName",
            option: {
              rules: [{ required: true, message: "请填写步骤名称！" }]
            }
          },
          {
            label: "SQL语句",
            name: "SqlSentence",
            type: "textarea",
            option: {
              rules: [{ required: true, message: "请填写SQL语句！" }]
            },
            props: { autosize: { minRows: 6, maxRows: 8 } }
          }
        ]
      },
      grid: {
        api: "NightCheckStep_List",
        //pagination: false,
        //dataFeild: "Data",
        columns: [
          {
            title: "序号",
            width: "6%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "步骤序号",
            dataIndex: "StepNo",
            width: "8%"
          },
          {
            title: "步骤名称",
            dataIndex: "StepName",
            width: "20%"
          },
          {
            title: "SQL语句",
            dataIndex: "SqlSentence",
            customRender: text => {
              return <div style="word-break: break-all;">{text}</div>;
            },
            align: "left"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "15%",
            key: "action",
            //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {},
  // 计算属性
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped></style>
